import {
    CapacitorSQLite,
    SQLiteConnection,
} from "@capacitor-community/sqlite";
import { Capacitor } from "@capacitor/core";
import { SplashScreen } from '@capacitor/splash-screen';
import { defineCustomElements } from "@ionic/pwa-elements/loader";
import { JeepSqlite } from 'jeep-sqlite/dist/components/jeep-sqlite';
import { useEffect, useState } from "react";
import { hydrateRoot } from "react-dom/client";
import { HelmetProvider } from 'react-helmet-async';
import App from "./App";
import { AuthProvider } from "./AuthProvider";
import { patchCordovaJs } from "./services/utils";
import * as serviceWorker from "./serviceWorker";


patchCordovaJs();

defineCustomElements(window);

// replace console.* for disable log on production
if (process.env.REACT_APP_PRODUCTION === "true" && process.env.REACT_APP_HOST_TYPE === "web") {
    console.log = () => {
    };
    console.error = () => {
    };
    console.debug = () => {
    };
}

declare global {
    interface Window {
        prerenderReady: boolean;
    }
}

const getFirebaseConfig = () => {
    const platform = Capacitor.getPlatform();

    const baseConfig = {
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN!,
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID!,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET!,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID!,
        measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID!,
        recaptchaSiteKey: process.env.REACT_APP_FIREBASE_RECAPTCHA_SITE_KEY!
    };

    switch (platform) {
        case 'ios':
            return {
                ...baseConfig,
                apiKey: process.env.REACT_APP_FIREBASE_API_KEY_IOS!,
                appId: process.env.REACT_APP_FIREBASE_APP_ID_IOS!,
            };
        case 'android':
            return {
                ...baseConfig,
                apiKey: process.env.REACT_APP_FIREBASE_API_KEY_ANDROID!,
                appId: process.env.REACT_APP_FIREBASE_APP_ID_ANDROID!,
            };
        default:
            return {
                ...baseConfig,
                apiKey: process.env.REACT_APP_FIREBASE_API_KEY!,
                appId: process.env.REACT_APP_FIREBASE_APP_ID!,
            };
    }
};

const Main = () => {
    const [hydrated, setHydrated] = useState(false);
    const firebaseConfig = getFirebaseConfig();

    useEffect(() => {
        setHydrated(true);
    }, []);

    if (!hydrated) {
        return null;
    }

    return (
        <HelmetProvider>
            <AuthProvider firebaseConfig={firebaseConfig}>
                <App />
            </AuthProvider>
        </HelmetProvider>
    );
};

const rootRender = () => {
    const container = document.getElementById("root");
    if (container) {
        hydrateRoot(container, <Main />);
    }
};

// USED FOR SQLITE INITIALIZATION

window.addEventListener("DOMContentLoaded", async () => {
    try {
        const platform = Capacitor.getPlatform();

        // Hide splash screen with fade
        await SplashScreen.hide({
            fadeOutDuration: 500
        });

        // WEB SPECIFIC FUNCTIONALITY
        if (platform === "web") {
            const sqlite = new SQLiteConnection(CapacitorSQLite);
            // Create the 'jeep-sqlite' Stencil component
            customElements.define("jeep-sqlite", JeepSqlite);
            const jeepSqliteEl = document.createElement("jeep-sqlite");
            document.body.appendChild(jeepSqliteEl);
            await customElements.whenDefined("jeep-sqlite");
            console.log(`after customElements.whenDefined`);

            // Initialize the Web store
            await sqlite.initWebStore();
            console.log(`after initWebStore`);
        }

        rootRender();
    } catch (e) {
        console.log(e);
    }
});


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
